import React, { FC, KeyboardEvent } from 'react'

import classes from './info-button.module.scss'

export interface InfoButtonProps {
  color: string
  backgroundColor: string
  size?: number
  onClick?: (event: React.SyntheticEvent<HTMLDivElement>) => void
  dataTestId?: string
}

export const InfoButton: FC<InfoButtonProps> = ({
  color,
  backgroundColor,
  size = 4,
  onClick,
  dataTestId,
}) => {
  const handleKeyDown = (event: KeyboardEvent<HTMLDivElement>) => {
    if (!onClick) return
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault()
      onClick(event)
    }
  }

  return (
    <div
      tabIndex={onClick ? 0 : undefined}
      role={onClick ? 'button' : undefined}
      aria-label={onClick ? 'More information' : undefined}
      aria-hidden={onClick === undefined}
      data-testid={dataTestId}
      className={classes.root}
      style={{
        color,
        backgroundColor,
        width: `${size * 8}px`,
        height: `${size * 8}px`,
      }}
      onClick={onClick}
      onKeyDown={handleKeyDown}
    >
      <span className={classes.text}>i</span>
    </div>
  )
}

export default InfoButton
